module.exports = __webpack_public_path__ + "static/media/ServicesResearchIcon.0890dcd8.svg";